import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';

import { ErrorComponent } from '@components/error-handling/error/error.component';
import { ErrorStore } from '@cxc/core/services';


@Component({
  selector: 'error-page',
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ErrorComponent],
})
export class ErrorPage implements OnDestroy {
  errorStore = inject(ErrorStore);

  ngOnDestroy(): void {
    this.errorStore.clear();
  }
}
